import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const LegalModal = ({ isOpen, toggle, title, children }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      className="legal-modal"
      scrollable
    >
      <ModalHeader toggle={toggle} className="legal-modal-header">
        {title}
      </ModalHeader>
      <ModalBody className="legal-modal-body">
        <div className="privacy-content">{children}</div>
      </ModalBody>
      <ModalFooter className="legal-modal-footer">
        <Button color="primary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LegalModal;
